import React, { memo, useState } from 'react';
import { tsToDateInput, dateInputToTs } from '../utils/labelUtils';
import { TrashIcon } from '../utils/LabelIcons';

const PhaseEditDialog = memo(({ phase, onSave, onCancel, onDelete }) => {
  const [draft, setDraft] = useState({ ...phase });
  const color = draft.color || '#888888';

  const setField = (field, value) =>
    setDraft((d) => ({
      ...d,
      [field]:
        field === 'tStart' || field === 'tEnd' ? dateInputToTs(value) : value,
    }));

  const canSave =
    draft.label?.trim().length > 0 &&
    !!draft.tStart &&
    !!draft.tEnd &&
    draft.tEnd > draft.tStart;

  return (
    <div className="leg-overlay" onMouseDown={onCancel}>
      <div className="leg-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="leg-dialog-header">
          <div className="leg-dialog-title-row">
            <svg width="16" height="10" viewBox="0 0 16 10">
              <rect x="0" y="3" width="16" height="4" rx="2" fill={color} />
            </svg>
            <span className="leg-dialog-title">Éditer la phase</span>
          </div>
          <div className="leg-dialog-header-actions">
            <button className="leg-dialog-close" onClick={onCancel}>
              ✕
            </button>
          </div>
        </div>
        {/* TODO ajouter un sélecteur pour choisir si on crée la phase sur un capteur + position ou sur le graphe directement*/}
        <div className="leg-form-grid">
          <span className="leg-field-label">Nom</span>
          <input
            type="text"
            value={draft.label || ''}
            placeholder="Nom de la phase…"
            onChange={(e) => setField('label', e.target.value)}
            className="leg-input"
          />
          <span className="leg-field-label">Début</span>
          <input
            type="date"
            value={tsToDateInput(draft.tStart)}
            onChange={(e) => setField('tStart', e.target.value)}
            className="leg-input"
          />
          <span className="leg-field-label">Fin</span>
          <input
            type="date"
            value={tsToDateInput(draft.tEnd)}
            onChange={(e) => setField('tEnd', e.target.value)}
            className="leg-input"
          />
          <span className="leg-field-label">Couleur</span>
          <input
            type="color"
            value={draft.color}
            onChange={(e) => setField('color', e.target.value)}
            className="leg-color-picker"
          />
        </div>
        <div className="leg-dialog-actions">
          {onDelete && (
            <button
              className="leg-btn-trash"
              onClick={() => onDelete(draft)}
              title="Supprimer"
              style={{ marginRight: 'auto' }}
            >
              <TrashIcon size={14} />
            </button>
          )}
          <button className="leg-btn-clear" onClick={onCancel}>
            Annuler
          </button>
          <button
            className="leg-btn-add"
            onClick={() => onSave(draft)}
            disabled={!canSave}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
});

export default PhaseEditDialog;
